import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import PaperDraggable from "../../../../../../../../components/PaperDraggable"

export default function DialogFecharCheckout({
    open,
    handleClose,
    onConfirmar
}: DialogFecharCheckoutProps) {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
                Fechar checkout
            </DialogTitle>
          
                <DialogContent>
                 <DialogContentText><b>Atenção:</b> Esta ação removerá as formas de recebimento e os valores adicionados. Deseja continuar?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                    <Button onClick={onConfirmar} variant="contained">Confirmar</Button>
                </DialogActions>
        </Dialog>
    )
}

interface DialogFecharCheckoutProps {
    open: boolean,
    handleClose: () => void,
    onConfirmar: () => void
}
